import styled from 'styled-components'

// Functions that generate CSS for layout properties
export const cssFuncs = {
  container: (container, theme) => `
    width: 100%;
    max-width: ${theme.globals.containerWidth}px;
    ${theme.mixins.pX(1.5)}
    margin-left: auto;
    margin-right: auto;
  `,
  center: position => `
    position: ${position};
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  `,
  textAlign: textAlign =>
    textAlign === 'center' ? 'text-align: center;' : textAlign === 'left' ? 'text-align: left;' : '',
  display: display => `display: ${display};`,
  wrap: () => `flex-wrap: wrap;`,
  gap: (gap, theme) => `grid-gap: ${theme.spacing(gap)}px;`,
  gapY: (gap, theme) => `grid-row-gap: ${theme.spacing(gap)}px;`,
  gapX: (gap, theme) => `grid-column-gap: ${theme.spacing(gap)}px;`,
  jc: jc => `justify-content: ${jc};`,
  ji: ji => `justify-items: ${ji};`,
  js: js => `justify-self: ${js};`,
  ac: ac => `align-content: ${ac};`,
  ai: ai => `align-items: ${ai};`,
  alignSelf: alignSelf => `align-self: ${alignSelf};`,
  flow: flow => `flex-direction: ${flow}; grid-auto-flow: ${flow};`,
  rows: rows => `grid-template-rows: ${rows};`,
  autoRows: rows => `grid-auto-rows: ${rows};`,
  column: column => `grid-column: ${column};`,
  columns: columns => `grid-template-columns: ${columns};`,
  autoColumns: columns => `grid-auto-columns: ${columns};`,
  grow: () => `flex-grow: 1; height: 100%; width: 100%;`,
  color: (color, theme) =>
    color && color.charAt(0) === '#' ? `color: ${color};` : color ? `color: ${theme.palette.text[color]};` : '',
  bgColor: (bgColor, theme) =>
    bgColor && (bgColor.charAt(0) === '#' || bgColor.charAt(0) === 'r')
      ? `background-color: ${bgColor};`
      : bgColor
      ? `background-color: ${theme.palette.bg[bgColor]?.main}; color: ${theme.palette.bg[bgColor]?.text};`
      : '',
  bgImg: bgImg =>
    `background-image: url(${bgImg}); background-size: cover; background-repeat: no-repeat; background-position: center;`,
  z: (z, theme) => `z-index: ${theme.zIndex[z]};`,
  position: position => `position: ${position};`,
  height: height => `height: ${height};`,
  width: width => (width ? `width: ${width};` : 'width: 100%;'),
  minY: height => `min-height: ${height};`,
  minX: width => `min-width: ${width};`,
  maxX: width => `max-width: ${width};`,
  maxY: height => `max-height: ${height};`,
  p: (padding, theme) => `padding: ${theme.mixins.p(padding)};`,
  pY: (padding, theme) => theme.mixins.pY(padding),
  pX: (padding, theme) => theme.mixins.pX(padding),
  pT: (padding, theme) => `padding-top: ${theme.spacing(padding)}px;`,
  pB: (padding, theme) => `padding-bottom: ${theme.spacing(padding)}px;`,
  pL: (padding, theme) => `padding-left: ${theme.spacing(padding)}px;`,
  pR: (padding, theme) => `padding-right: ${theme.spacing(padding)}px;`,
  mY: (margin, theme) => theme.mixins.mY(margin),
  mYAuto: () => `margin-top: auto; margin-bottom: auto;`,
  mX: (margin, theme) => theme.mixins.mX(margin),
  mXAuto: () => `margin-left: auto; margin-right: auto;`,
  mL: (margin, theme) => `margin-left: ${theme.spacing(margin)}px;`,
  mR: (margin, theme) => `margin-right: ${theme.spacing(margin)}px;`,
  mB: (margin, theme) => `margin-bottom: ${theme.spacing(margin)}px;`,
  t: position => `top: ${position};`,
  b: position => `bottom: ${position};`,
  l: position => `left: ${position};`,
  r: position => `right: ${position};`,
  overflowX: overflow => `overflow-x: ${overflow};`,
  overflowY: overflow => `overflow-y: ${overflow};`,
  overflow: overflow => `overflow: ${overflow};`,
  selectable: () =>
    `user-select: none; cursor: pointer; -webkit-tap-highlight-color: rgba(0,0,0,0); -webkit-tap-highlight-color: transparent;`,
  noEvent: () => `pointer-events: none;`,
}

const L = styled.div`
  ${props => props.theme.mixins.runCSSFuncs(props, cssFuncs)}
`

export default L
